// Client Book: details. The Client Details tab of the client record
// (`wealth.crm.client-book.details`, ADR-0027): the trading accounts and their
// holdings, the Accounts, the GPP block and, for an entity, the entity
// sections of its suitability record.
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';

const ClientDetailsTabSlot = lazy(() =>
    import('./client-book.slots').then((m) => ({ default: m.ClientDetailsTabSlot })),
);

export default defineWebFeature({
    id: 'wealth.crm.client-book.details',
    slots: {
        'client.detail.tabs': [
            { key: 'details', order: 10, label: 'Client Details', Component: ClientDetailsTabSlot },
        ],
    },
});
